// extracted by css-extract-rspack-plugin
export default {"cls1":"RemovedItemNotice-cls1_WDE","cls2":"RemovedItemNotice-cls2_Mp6 RemovedItemNotice-cls1_WDE"};